/* eslint-disable react/no-array-index-key */
/* eslint-disable  react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// import { useNavigate } from 'react-router-dom';
import { Card, Col, Row } from 'react-bootstrap';
// import { MdAssignment, MdBlockFlipped } from 'react-icons/md';
import '../../hotels/booking-details/BookingsList.scss';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
} from '../../../shared/constants/Constants';
import AppLink from '../../../shared/components/app-link/AppLink';
// import {
//   TicketsIcon,
//   VoucherIcon,
// } from '../../../shared/components/app-icons/AppIcons';
import {
  formatCurrency,
  formatDate,
  getNewDate,
} from '../../../shared/helper-utils/appUtils';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import { debounce } from '../../../api/apiUtils';

// const iconStyle = { fontSize: 22, marginRight: 8, color: '#374471' };

function BusCancellationList({ busCancellations }) {
  const [searchText, setSearchText] = useState('');
  const [transactionsList, setTransactionsList] = useState([]);

  const getCancellationDetailsLink = (txId) => {
    let route = NAVIGATION_ROUTES.BUS.BOOKING_CANCEL_DETAILS;
    route = route.replace(':transactionId', txId);
    return route;
  };

  const getBusCreditNotePage = (txid) => {
    let route = NAVIGATION_ROUTES.BUS.BUS_CREDIT_NOTE;
    route = route.replace(':transactionId', txid);
    return route;
  };

  useEffect(() => {
    setTransactionsList(busCancellations);
  }, [busCancellations]);

  const setSearchResults = debounce((val) => {
    let data = [...busCancellations];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(val.toLowerCase()),
        ),
      );
    }
    setTransactionsList(data);
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  return (
    <section className="booking-list-page">
      <div className="train-search-container">
        <div className=" d-flex justify-content-end">
          <div style={{ width: '300px' }}>
            <AppTextInput
              value={searchText}
              label="search"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div className="booking-list-page__body">
        <div className="pt-2">
          {transactionsList.map((item, index) => (
            <Card className="booking-list-card" key={index}>
              <Row>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <Card.Body className="booking-list-card__body">
                    <Row className="spacing-16">
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          TxID
                        </span>
                        <AppLink
                          linkText={item.Txid}
                          isLink
                          href={getCancellationDetailsLink(item.Txid)}
                          className="booking-list-card__body_value primary-color"
                        />
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Tx Date
                        </span>
                        <span className="booking-list-card__body_value">
                          {item.TxDate}
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Refund TxID
                        </span>
                        <span className="booking-list-card__body_value">
                          {item.ReferenceTxid}
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Refund TxDate
                        </span>
                        <span className="booking-list-card__body_value">
                          {item.RefundDate
                            ? formatDate(
                                getNewDate(item.RefundDate),
                                DATE_MONTH_YEAR_VIEW_FORMAT,
                              )
                            : ''}
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Bus CreditNote no
                        </span>
                        <span className="booking-list-card__body_value text-uppercase">
                          {item.InvoiceNumber}
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Bus Ref Inv No
                        </span>
                        <span className="booking-list-card__body_value text-uppercase">
                          {item.BookingInvoiceNumber}
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Pax Name
                        </span>
                        <span className="booking-list-card__body_value">
                          {item.PaxName}
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Agent Id
                        </span>
                        <span className="booking-list-card__body_value text-uppercase">
                          {item.AgentId}
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Status
                        </span>
                        <span className="booking-list-card__body_value text-uppercase">
                          {item.Status}
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Refund Amount
                        </span>
                        <span className="booking-list-card__body_value text-uppercase">
                          {formatCurrency(item.RefundAmount || 0)}
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <span className="booking-list-card__body_header">
                          Remarks
                        </span>
                        <span className="booking-list-card__body_value">
                          <small>{item.Remarks}</small>
                        </span>
                      </Col>
                      <Col
                        className="d-flex flex-column"
                        lg={2}
                        md={4}
                        sm={6}
                        xs={12}
                      >
                        <AppLink
                          isLink
                          linkText="Refund Receipt"
                          href={getBusCreditNotePage(item.Txid)}
                          variant="purple"
                          target="_blank"
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Col>
                {/* <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="booking-list-card__actions">
                    <Row className="spacing-0">
                      <Col
                        className="border-767px-bottom"
                        lg={6}
                        md={6}
                        sm={6}
                        xs={12}
                      >
                        <VoucherIcon style={iconStyle} />
                        <AppLink
                          linkText="View Details"
                          // linkText="View Ticket"
                          onClick={() => viewDetails(item.Txid)}
                          variant="grey"
                        />
                      </Col>
                      <Col
                        className="border-767px-bottom"
                        lg={6}
                        md={6}
                        sm={6}
                        xs={12}
                      >
                        <TicketsIcon style={iconStyle} />
                        <AppLink
                          linkText="View Ticket"
                          onClick={() => printTickets(item.Txid)}
                          variant="grey"
                        />
                      </Col> */}
                {/* <Col lg={3} md={3} sm={6} xs={12}>
                        <MdAssignment style={iconStyle} />
                        <AppLink
                          linkText="Booking Voucher"
                          onClick={bookingVoucher}
                          variant="grey"
                        />
                      </Col>
                      <Col
                        className="border-end-0"
                        lg={3}
                        md={3}
                        sm={6}
                        xs={12}
                      >
                        <MdBlockFlipped style={iconStyle} />
                        <AppLink
                          linkText="Cancel"
                          onClick={() => cancelBooking(item.txid)}
                          variant="grey"
                        />
                      </Col> */}
                {/* </Row>
                  </div>
                </Col> */}
              </Row>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

BusCancellationList.defaultProps = {};

BusCancellationList.propTypes = {
  busCancellations: PropTypes.array.isRequired,
};

export default BusCancellationList;
